import produce, { enableES5, enableMapSet, setAutoFreeze, setUseProxies } from 'immer';
import { isNode } from '@jupiter-app/utils';
import { combineReducers } from '@reduck/core';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var hasProxies = typeof Proxy !== 'undefined' && typeof Proxy.revocable !== 'undefined' && typeof Reflect !== 'undefined';
enableES5();
enableMapSet();
setAutoFreeze(false);
hasProxies && setUseProxies(false);

function combineReducersWithImmer(context) {
  var reducersWithImmer = {};
  return function (reducers) {
    Object.keys(reducers).forEach(function (key) {
      var reducerFn = reducers[key];

      reducersWithImmer[key] = function (state, payload) {
        var modelDesc = context._models[key]; // 为了兼容 redux 项目，只有 Reduck model，才用 immer 插件处理

        if (!modelDesc) {
          return reducerFn(state, payload);
        } // record last state


        context._lastState[key] = state;

        if (!state) {
          state = _objectSpread2({}, modelDesc === null || modelDesc === void 0 ? void 0 : modelDesc.initialState);
        }

        if (_typeof(state) === 'object') {
          var curModelDescriptors = context._descriptors[modelDesc.name]; // immer 第三方插件要求 state 结构没有被修改过，所以此处先把 descriptors delete

          var deleteDesc = function deleteDesc(s) {
            if (curModelDescriptors && s) {
              // 先重新计算 computed，更新一下缓存
              Object.keys(curModelDescriptors).forEach(function (descriptorKey) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                s[descriptorKey];
              });
              Object.keys(curModelDescriptors).forEach(function (descriptorKey) {
                delete s[descriptorKey];
              });
            }
          };

          deleteDesc(state); // let markNextUndefined = false;

          var result = produce(state, function (draft) {
            curModelDescriptors && Object.defineProperties(draft, curModelDescriptors); // 新的状态数据要添加之前的 descriptors

            var next = reducerFn(draft, payload);

            if (_typeof(next) === 'object') {
              deleteDesc(next);
              return next;
            } // markNextUndefined = true;


            return undefined;
          }); //             if (process.env.NODE_ENV !== 'production') {
          //               // wrong operatation
          //               if (result === state && markNextUndefined) {
          //                 console.warn(
          //                   `Warning, some model.actions is wraong. such as:
          // The following operation(Model.actions) is Wrong: \n
          // { test(state, payload) { state.xxx = payload; return state; } } \n
          // The Right operation: \n
          // (1) immer operate: \n
          // { test(state, payload) { state.xxx = payload; } } \n
          // (2) not immer operate: \n
          // { test(state, payload) { return { ...state, xxx: payload }; } }`,
          //                 );
          //               }
          //             }
          // immer 插件处理完后，再将 descriptors 添加
          // 旧的状态数据也要恢复

          curModelDescriptors && Object.defineProperties(state, curModelDescriptors); // 新的状态数据要添加之前的 descriptors

          curModelDescriptors && Object.defineProperties(result, curModelDescriptors);
          return result;
        } else {
          return reducerFn(state, payload);
        }
      };
    });
    return combineReducers(reducersWithImmer);
  };
}

var plugin = function plugin(context) {
  // window special tag
  if (!isNode) {
    window.__REDUCK_IMMER__ = true;
  }

  return {
    name: '@reduck/plugin-immer',
    override: {
      // 覆写 redux 的相关api
      combineReducers: combineReducersWithImmer(context)
    }
  };
};

plugin.__name__ = '@reduck/plugin-immer';

export default plugin;
//# sourceMappingURL=immer.esm.js.map
